import { createAsyncThunk } from '@reduxjs/toolkit';
import toDoService from '../../../api/services/toDo';

export const getClientToDos = createAsyncThunk('todo/getClientToDos', async requestData => {
  return await toDoService.getClientToDos(requestData);
});

export const createToDoForClient = createAsyncThunk('todo/createToDoForClient', async ({ id, body }) => {
  return await toDoService.createToDoForClient(id, body);
});

export const deleteToDoForClient = createAsyncThunk('todo/deleteToDoForClient', async id => {
  return await toDoService.deleteToDoForClient(id);
});

export const createTemplateToDo = createAsyncThunk('todo/createTemplateToDo', async requestData => {
  return await toDoService.createTemplateToDo(requestData);
});

export const getToDoTemplates = createAsyncThunk('todo/getToDoTemplates', async ({ page }) => {
  return await toDoService.getToDoTemplates(page);
});

export const createTemplateToDoForClient = createAsyncThunk(
  'todo/createTemplateToDoForClient',
  async ({ id, templates }) => {
    return await toDoService.createTemplateToDoForClient(id, templates);
  },
);

export const editClientToDo = createAsyncThunk('todo/editClientToDo', async ({ id, body }) => {
  return await toDoService.editClientToDo(id, body);
});

export const getToDoTemplateById = createAsyncThunk('todo/getToDoTemplateById', async id => {
  return await toDoService.getToDoTemplateById(id);
});

export const editTemplateToDo = createAsyncThunk('todo/editTemplateToDo', async ({ id, body }) => {
  return await toDoService.editTemplateToDo(id, body);
});

export const deleteToDoTemplate = createAsyncThunk('todo/deleteToDoTemplate', async ({ id }) => {
  return await toDoService.deleteToDoTemplate(id);
});
